import { render } from "./CounteragentCreate.vue?vue&type=template&id=5a59f752"
import script from "./CounteragentCreate.vue?vue&type=script&lang=js"
export * from "./CounteragentCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__